import { useEffect, useState } from 'react';
import { apiCall } from '../../../../../../crud/api.crud';
import useStore from '../../../../../../store/zustand/store';

const useChageProfile = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const [change, setChange] = useState(false);
  const [birthdateError, setBirthdateError] = useState(false);
  const updateUser = useStore((state) => state.updateUser);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setChange(false);
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [change]);

  const update = async ({
    endpoint = 'profile',
    method = 'POST',
    data,
    isFormData = false,
  }: {
    endpoint?: string;
    method?: string;
    data: any;
    isFormData?: boolean;
  }) => {
    setIsLoading(true);
    setBirthdateError(false);
    setError(false);

    try {
      const headers = isFormData ? undefined : { 'Content-Type': 'application/json' };

      const body = isFormData ? data : JSON.stringify(data);

      const response = await apiCall(endpoint, body, method,'json', headers);
      
      if (response?.data?.data?.[0]) {
        updateUser(response.data.data[0]);
        setChange(true);
      }
    } catch (e) {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { change, isLoading, error, update, birthdateError, setBirthdateError };
};

export default useChageProfile;
